import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './Testimonials.module.scss';
import Container from "../../hoc/Container/Container";
import openQuotes from '../../assets/open-quotes.svg';

const Testimonials = ({
                        authorImg,
                        decorativeImg,
                        company,
                        name,
                        quote
                      }) => (
  <section className={styles['testimonial__section']}>
    <Container>
      <img src={decorativeImg} alt="" className={styles['testimonials-decorator']}/>
      <div className={styles['testimonial']}>
        <div className={styles['testimonial__img-container']}>
          <div className={styles['testimonial__img_background']}></div>
          <img
            className={styles['testimonial__img']}
            src={authorImg}
            alt=""/>
        </div>

        <div className={styles['testimonial__content']}>
          <div className={styles['testimonial__quote-container']}>
            <img src={openQuotes} alt="" />
            <p className={styles['testimonial__quote']}>
              {quote}
            </p>
            <span className={styles['testimonial__company']}>{company}</span>
            <p className={styles['testimonial__name']}>{name}</p>
          </div>          
        </div>
      </div>
    </Container>
  </section>
);

Testimonials.propTypes = {
  authorImg: PropTypes.string,
  company: PropTypes.string,
  name: PropTypes.string,
  quote: PropTypes.string
};

export default Testimonials;